import { Link, useLocation} from "react-router-dom";

import Catalog from "../../component/catalog/Catalog"
import styles from "./productCatalog.module.css"
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { useTranslation } from "react-i18next";

export default function ProductCatalog(){
	const { t } = useTranslation();
	useDocumentTitle(t("Product Catalog"))
    return <Catalog RenderCards={RenderCards}/>
}

function RenderCards({data}){
	const { pathname } = useLocation();
	return <div className='catalog__body--list'>
	{data?.list &&
		Object.entries(data.list).map(([title, details]) => {
			const path = pathname;
			return (
				<ProductCard
					key={title}
					data={{
						title,
						...details,
					}}
					path={path}
					isProduct={data?.isProduct}
					isAsset={data?.isAsset}
				/>
			);
		})}
		</div>
}

function ProductCard({ data, path, isProduct }) {
	const location = useLocation();
	const { title, route, imageUrl, globalModelName } = data;
	const cfmGlobalModelName = [title, globalModelName].filter(Boolean).join(' | ');

	const createBreadcrumbProduct = () => {
		if (!isProduct) return;

		const currentPath = location.pathname;

	 	const productRelatedBreadcrumbsIds = getAllProductRelatedBreadcrumbsIds(currentPath, route);

    	sessionStorage.setItem('productRelatedBreadcrumbsIds', productRelatedBreadcrumbsIds);
	};

	return (
		<Link title={cfmGlobalModelName}
			to={isProduct ? `/product/${route}` : `${path}/${route}`}
			className={styles.category__card} onClick={createBreadcrumbProduct} >
			<div className={styles['category__card--img']}>
				<img src={imageUrl} loading='eager' />
			</div>
			<div className={`horizontal-ruler ${styles['category__card--ruler']}`} />
			<div className={styles['category__card--title']}>
				<h3>{cfmGlobalModelName}</h3>
			</div>
		</Link>
	);
}

function getAllProductRelatedBreadcrumbsIds(locationPath, productRoute) {
  const idsFromPath = locationPath
    .split('/')
    .filter(Boolean)
    .slice(1)
    .map(segment => {
      const match = segment.match(/-(\d+)$/);
      return match ? match[1] : null;
    })
    .filter(Boolean);

  const productIdMatch = productRoute.match(/-(\d+)$/);
  if (!productIdMatch) {
    return idsFromPath.join('-');
  }

  const productId = productIdMatch[1];

  return [...idsFromPath, productId].join('-');
}